import { Button, Layout, Skeleton, theme, Typography } from "antd";
import React, { useEffect, useRef } from "react";
import {
  getPrincipalUsers,
  initPrincipalSlice,
} from "../Slices/Principal.slice";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../../shared/components/CustomTable";
import routes from "../../../engine/routes";
import { IoAddSharp } from "react-icons/io5";
import { renderUserGender, renderUserName } from "../../../utils/constants";
import { UserCanDoActionMemo } from "../../../engine/AuthRoute";

const { Content, Sider, Header, Footer } = Layout;

export function PrincipalUsers({ unitId, expanded, onClose }) {
  const { id } = useParams();

  const { principal, loading, users } = useSelector(state => state.principal);

  const { init, clear } = initPrincipalSlice({ id });

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  useEffect(() => {
    if (id !== "new") {
      dispatch(getPrincipalUsers(id));
    }
    return () => {};
  }, []);

  const { name } = principal;

  const m2Exposant = (
    <span>
      m<sup>2</sup>
    </span>
  );

  const inputs = [
    {
      parentLabel: "",
      children: [],
    },
    // {
    //   parentLabel: 'Information',
    //   children: [
    //     {
    //       required: true,
    //       label: 'Prix',
    //       placeholder: 'prix',
    //       addonBefore: 'CHF',
    //       name: 'info.price',
    //       value: '',
    //       type: 'input-currency',
    //       col: 4,
    //     },
    //   ],
    // },
    {
      children: [
        {
          label: "Sauvegarder",
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
  const formatString = s => {
    return Number(s.replace(/[^0-9.-]+/g, ""));
  };
  const onSubmitForm = data => {
    dispatch(setPropertiesPrestation(data));
  };

  const renderSearchChild = () => {
    return <div>Search</div>;
  };

  const columns = [
    {
      title: "Nom & Prénom",
      dataIndex: "user",
      key: "user",
      render: (text, record) => renderUserName(record),
    },
    {
      title: "Genre",
      dataIndex: "genre",
      key: "genre",
      render: (text, record) => renderUserGender(record),
    },
    {
      title: "E-mail",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Téléphone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <div>
          <Button size={"small"}>Action</Button>
        </div>
      ),
    },
  ];

  return (
    <>
      <div
        style={{
          // marginTop: "30px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={3} className={""}>
          {principal.name} / Utilisateurs
        </Typography.Title>
        <UserCanDoActionMemo
          route={routes.principals(id).detailUsers}
          action={"c"}
        >
          <Link to={routes.principals(id).detailUser("new").path}>
            <Button
              size={"middle"}
              type={"primary"}
              style={{ justifySelf: "flex-start", display: "flex" }}
              icon={<IoAddSharp style={{ marginTop: "0px" }} size={25} />}
            >
              Nouvel utilisateur
            </Button>
          </Link>
        </UserCanDoActionMemo>
      </div>
      <br />

      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <CustomTable
            columns={columns}
            dataSource={users}
            onRowLink={record =>
              routes.principals(id).detailUser(record._id).path
            }
          />
          {/*<CustomForm*/}
          {/*  dataSource={inputs}*/}
          {/*  handleSubmit={data => onSubmitForm(data)}*/}
          {/*  labelCol={24}*/}
          {/*  refForm={formRef}*/}
          {/*  wrapperCol={24}*/}
          {/*  onValuesChange={undefined}*/}
          {/*/>*/}
        </>
      )}
    </>
  );
}
